import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { HttpParamsService } from '../../../../../shared/services/http-params.service';
import { WarehouseModel } from '../models/warehouse.models';

@Injectable({
  providedIn: 'root',
})
export class WarehouseService {
  private readonly BASE: string = `${environment.inventoryApiUrl}/Warehouses`;

  private readonly GET_ALL = (): string => `${this.BASE}`;
  private readonly GET_BY_ID = (id: number): string => `${this.BASE}/${id}`;
  private readonly CREATE = (): string => `${this.BASE}`;
  private readonly CREATE_BULK = (): string => `${this.BASE}/Bulk`;
  private readonly UPDATE = (id: number): string => `${this.BASE}/${id}`;
  private readonly DELETE = (id: number): string => `${this.BASE}/${id}`;
  private readonly CHANGE_WAREHOUSE_STATUS = (id: number): string =>
    `${this.BASE}/${id}/ChangeStatus`;

  constructor(
    private http: HttpClient,
    private httpParamsService: HttpParamsService,
  ) {}

  getAllWarehouses(queryParams: Record<string, any>): Observable<WarehouseModel[]> {
    const params: HttpParams = this.httpParamsService.buildCleanHttpParams(queryParams);
    return this.http.get<WarehouseModel[]>(this.GET_ALL(), { params });
  }
  getWarehouseById(id: number): Observable<WarehouseModel> {
    return this.http.get<WarehouseModel>(this.GET_BY_ID(id));
  }

  createWarehouse(warehouse: any) {
    return this.http.post(this.CREATE(), warehouse);
  }

  createBulkWarehouses(wareHousesList: any[]) {
    return this.http.post<any[]>(this.CREATE_BULK(), wareHousesList);
  }

  deleteWarehouse(id: number) {
    return this.http.delete<boolean>(this.DELETE(id));
  }

  updateWarehouse(warehouse: any, id: number) {
    return this.http.put(this.UPDATE(id), warehouse);
  }

  changeWarehouseStatus(id: number, status: number) {
    return this.http.put(this.CHANGE_WAREHOUSE_STATUS(id), { status });
  }
}
